import { appConfig } from '../../configs/app-config';

import { API_VERSION } from '../../constants/api-constants';
import CycleChartV2 from './CycleChartV2';
import { CycleChartData } from './CycleChartData/CycleChartData';

export const CycleChartWrapper = appConfig.apiVersion === API_VERSION.V2 ? CycleChartV2 : CycleChartData;